
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCheckmarkDisable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 16,
  height: 16,
  textRendering: "geometricPrecision",
  viewBox: "0 0 16 16"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXGYmJiYmJigoKCdnZ2Xl5ebm5uYmJiXl5fi30AvAAAACHRSTlMAyuEPH7IXJQDl8PQAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAA8SURBVHjaY2CgKmBjZEXhMzNyMEKZrKzMYD4TG1QAKMUM4rPAFLMwcTAi88EiKHwGBnYmJnZUK5mp6gMAXBsAqd9/tCUAAAAASUVORK5CYII=",
  width: 16,
  height: 16,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXGYmJiYmJigoKCdnZ2Xl5ebm5uYmJiXl5fi30AvAAAACHRSTlMAyuEPH7IXJQDl8PQAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAA8SURBVHjaY2CgKmBjZEXhMzNyMEKZrKzMYD4TG1QAKMUM4rPAFLMwcTAi88EiKHwGBnYmJnZUK5mp6gMAXBsAqd9/tCUAAAAASUVORK5CYII=",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16\" height=\"16\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 16 16\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXGYmJiYmJigoKCdnZ2Xl5ebm5uYmJiXl5fi30AvAAAACHRSTlMAyuEPH7IXJQDl8PQAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAA8SURBVHjaY2CgKmBjZEXhMzNyMEKZrKzMYD4TG1QAKMUM4rPAFLMwcTAi88EiKHwGBnYmJnZUK5mp6gMAXBsAqd9/tCUAAAAASUVORK5CYII=\" width=\"16\" height=\"16\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAG1BMVEVMaXGYmJiYmJigoKCdnZ2Xl5ebm5uYmJiXl5fi30AvAAAACHRSTlMAyuEPH7IXJQDl8PQAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAA8SURBVHjaY2CgKmBjZEXhMzNyMEKZrKzMYD4TG1QAKMUM4rPAFLMwcTAi88EiKHwGBnYmJnZUK5mp6gMAXBsAqd9/tCUAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-checkmark-disable.f1bf78522f8fd8cf531ff4dbd2be3542.svg"),
        {
          React: SvgIconCheckmarkDisable,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      